import { render, staticRenderFns } from "./DraggableOptionItem.vue?vue&type=template&id=79ef4cc7&scoped=true&"
import script from "./DraggableOptionItem.vue?vue&type=script&lang=ts&"
export * from "./DraggableOptionItem.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableOptionItem.vue?vue&type=style&index=0&id=79ef4cc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef4cc7",
  null
  
)

export default component.exports